import {
  FETCH_INSTITUTION_SPEAKERS_LIST,
  SPEAKER_LOADING,
  SPEAKER_IS_END,
  SPEAKER_IS_EMPTY,
  SET_SPEAKER_DOC_PROPERTY,
} from "./../Actions/SpeakerAction";

const initialState = {
  list: [],
  isEmpty: false,
  loading: false,
  isEnd: false,
};

const speakerReducer = (state = initialState, actions) => {
  const { type, payload } = actions;
  switch (type) {
    case SPEAKER_IS_END: {
      return {
        ...state,
        ...payload,
      };
    }
    case SPEAKER_LOADING: {
      return {
        ...state,
        ...payload,
      };
    }
    case SPEAKER_IS_EMPTY: {
      return {
        ...state,
        ...payload,
      };
    }
    case FETCH_INSTITUTION_SPEAKERS_LIST: {
      return {
        ...state,
        list: [...payload.list],
      };
    }
    case SET_SPEAKER_DOC_PROPERTY: {
      return setDocProperty(state, payload);
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

const setDocProperty = (state, { val, name, docId }) => {
  const listClone = [...state.list];

  const findIndexOfDoc = listClone.findIndex((_o) => _o.docId === docId);

  if (findIndexOfDoc >= 0) {
    const docClone = { ...listClone[findIndexOfDoc] };
    docClone[name] = val;

    listClone[findIndexOfDoc] = docClone;

    return {
      ...state,
      list: [...listClone],
    };
  } else {
    return {
      ...state,
    };
  }
};
export default speakerReducer;
